import { useState } from 'react';
import axiosService from '../../../../service_v2/common/axios-service';
import { MP_CF_QALBOX_COURSE_MODULE } from '../../../../Constants';
import { toast } from 'react-toastify';

export const useUpdateResources = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const updateResourcesHook = async (moduleId, resources, handleUpdates) => {
    setLoading(true);
    setError(null);
    setSuccess(false);
  
    try {
      const requests = resources.map((resource) =>
        axiosService.put(
          `${process.env.REACT_APP_MP_CF_GEN2_API_BASE_URL}${MP_CF_QALBOX_COURSE_MODULE}/${moduleId}/resources`,
          { resource: resource }
        )
      );
  
      // Wait for all API calls to complete
      const responses = await Promise.all(requests);
  
      // Check if all requests were successful
      const allSuccessful = responses.every((res) => res.status === 200);
  
      if (allSuccessful) {
        setSuccess(true);
        toast.success(`Resources updated successfully.`, {
          position: toast.POSITION.BOTTOM_LEFT,
        });
        handleUpdates();
      } else {
        setError("Some resources failed to update.");
      }
    } catch (error) {
      setError("An error occurred while updating resources.");
    } finally {
      setLoading(false);
    }
  };
  

  return [ updateResourcesHook, loading, error, success ];
};